import { render, staticRenderFns } from "./companyMailItem.vue?vue&type=template&id=b2e187aa&scoped=true"
import script from "./companyMailItem.vue?vue&type=script&lang=js"
export * from "./companyMailItem.vue?vue&type=script&lang=js"
import style0 from "./companyMailItem.vue?vue&type=style&index=0&id=b2e187aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e187aa",
  null
  
)

export default component.exports